export const toConversationMessage = (
  message: string,
  role: string,
  isFinished = false,
  isValidatedPromptType = false
) => ({
  message,
  role,
  isFinished,
  isValidatedPromptType,
})
